import React, { useState, useRef, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';
//styles
import styles from 'src/asset/scss/styles/notify.module.scss';
//hook
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//CompWrapper
import Section from 'src/webapp/views/wrapper/Section';
import Container from 'src/webapp/views/wrapper/Container';
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
import ActiveButtonWrapper from 'src/webapp/views/wrapper/ActiveButtonWrapper';
//Comp
import Menu from 'src/webapp/views/component/Menu';//메뉴
import Titlebar from 'src/webapp/views/component/Titlebar';//상단타이틀
import Element from 'src/webapp/views/wrapper/Element';
import InViewData from 'src/webapp/views/component/data/InViewData';//데이터로드확인
import ProductList from './ProductList';

export default function Product() {
    const { axiosPostHandler } = useAxiosHook();//axios
    /* ====================쿠폰리스트API ==================== */
    const pageRef = useRef(20);
    const isLock = useRef(false);
    const [productList, setProductList] = useState(null);
    const memberProductListAPI = async () => {
        if (isLock.current || !pageRef.current) { return; }
        const rownum = pageRef.current;
        
        try {
            isLock.current = true;
            
            const DATA = { TYP:1, STATE: 1, ROWNUM: pageRef.current };
            const result = await axiosPostHandler(`siteProductListForAdmin.do`, DATA);
            /* ===== 결과처리 ===== */
            const isOk = result && result.message === "SUCCESS";
            const newList = isOk ? result.data : [];
            setProductList(prev => Array.isArray(prev) ? [...prev, ...newList] : [...newList]);
            pageRef.current = (isOk && result.data?.length >= 20) ? rownum + 20 : null;
        } finally {
            isLock.current = false;
        }
    }
    
    /* ========== useEffect 초기 실행 ========== */
    useEffect(() => {
        memberProductListAPI();
    }, [])
    /* ========== useEffect 초기 실행 ========== */
    /* ========== useEffect inView처리 ========== */
    const [inViewRef, inView] = useInView({ threshold: .5 });
    useEffect(() => {
        if(!inView || pageRef.current === null || !productList || isLock.current){return;}
        memberProductListAPI();
    }, [inView])
    /* ========== useEffect inView처리 ========== */
    /* ====================쿠폰리스트API ==================== */
    return (
        <>
            <Section>
                <Menu />{/* 메뉴 */}
                <Container>
                    <FixedPanel>
                        <Titlebar title={`상품`} dept={[{ label: '상품' }, { label: '상품 목록' }]} />{/* 상단타이틀 */}
                    </FixedPanel>
                    <FlickPanel className={styles.flickPanel}>
                        <ActiveButtonWrapper>
                            <Element tag={`div`} >
                                <Link to={'reg'}><span>상품 등록</span></Link>
                            </Element>
                        </ActiveButtonWrapper>
                        <ProductList list={productList} setList={setProductList} />
                        {productList?.length > 0 && pageRef.current != null ? <div ref={inViewRef}><InViewData inView={true} /></div>
                            : pageRef.current === null ? <InViewData readAll={true} />
                                : null}
                    </FlickPanel>
                </Container>
            </Section>
        </>
    )
}